export const WARNING_ICON_SIZE = {
  medium: 'tw-size-11',
  large: 'tw-size-16',
} as const

export const WARNING_ICON_SPACE = {
  medium: 'tw-mb-1',
  large: 'tw-mb-4',
} as const
